<template>
  <div id="app" :class="[isMobile ? 'mobile' : 'pc']">
    <div class="theme-f" :class="{ 'has-bar': hasBuyBar }">
      <headerVue :key="'hd' + componentKey" />
      <main class="f-main">
        <router-view @refresh="handleRefresh" />
      </main>
      <footerVue :key="'ft' + componentKey" />
    </div>
  </div>
</template>

<script>
import headerVue from './views/headerF.vue';
import footerVue from './views/footerF.vue';

// F 套两款字体：display 用 Bricolage Grotesque，正文用印尼设计师做的 Plus Jakarta Sans
const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500;12..96,700;12..96,800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';

export default {
  components: { headerVue, footerVue },
  data() {
    return {
      isMobile: false,
      componentKey: 0,
    }
  },
  computed: {
    // 移动端详情页、话费页底部有固定购买条，给页面多让出一段
    hasBuyBar() {
      return this.isMobile && /^\/(topup\/|mobile)/.test(this.$route.path)
    },
  },
  created() {
    this.loadFonts()
  },
  mounted() {
    this.isMobile = !!this._isMobile()
  },
  methods: {
    // 只有 F 套才拉这两款字体，其他皮肤不受影响
    loadFonts() {
      if (document.getElementById('theme-f-fonts')) return;
      const link = document.createElement('link')
      link.id = 'theme-f-fonts'
      link.rel = 'stylesheet'
      link.href = FONT_HREF
      document.head.appendChild(link)
    },
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    handleRefresh() {
      this.componentKey += 1
    },
  },
}
</script>

<style lang="scss">
@import './assets/css/reset.scss';
@import './assets/css/theme-f.scss';

/* 不在 html 上设背景：各皮肤的 App*.vue 全局样式都会打进包里，后加载的会盖掉别的品牌。
   F 的底色由 .theme-f 自己铺。 */
html.mobile {
  font-size: 13.3333vw;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;

  &.pc {
    min-width: 1200px;
    overflow-x: auto;
  }
}

/* 同 AppE：其他皮肤的全局样式也在包里，会把 #app.pc 设成 overflow-x:auto，
   #app 成了滚动容器后页头和详情页左栏的 position:sticky 会失效。用 html 前缀压过去。 */
html #app.pc {
  overflow-x: visible;
}
</style>
